import SEOLandingPage from "@/components/SEOLandingPage";

const UGCAgenturKoeln = () => (
  <SEOLandingPage
    lang="de"
    title="UGC Agentur Köln | AI UGC Creator Köln | Fuel72"
    metaDescription="UGC Agentur Köln: Professionelle AI UGC Videos für Kölner Unternehmen. 72 Stunden Lieferung."
    keywords="ugc agentur köln, ugc creator köln, ugc köln, ai ugc köln"
    canonical="https://www.fuel72.com/ugc-agentur-koeln"
    hreflang={[{ lang: "de", href: "https://www.fuel72.com/ugc-agentur-koeln" }]}
    heroTitle="UGC Agentur"
    heroHighlight="Köln"
    heroDescription="Professionelle AI UGC Videos für Kölner Unternehmen. 72 Stunden Lieferung."
    sections={[
      { title: "UGC Agentur Köln", content: "Köln ist eine der kreativsten Städte Deutschlands. Fuel72 liefert professionelle UGC Videos für Kölner Businesses.", items: ["UGC Videos für Kölner Unternehmen", "KI-generiert — schnell und günstig", "72 Stunden Lieferung", "Ab 49€ pro Video"] },
      { title: "UGC für Kölner Branchen", content: "Von Altstadt bis Ehrenfeld.", grid: [{ icon: "🍕", title: "Gastronomie", description: "Restaurants und Cafés." }, { icon: "🎭", title: "Events", description: "Kölns lebendige Szene." }, { icon: "🛍️", title: "Einzelhandel", description: "Shops und Boutiquen." }, { icon: "💼", title: "Dienstleister", description: "Service-Unternehmen." }] },
    ]}
    faqs={[{ question: "Gibt es eine UGC Agentur in Köln?", answer: "Ja! Fuel72 bedient Kölner Unternehmen mit 72-Stunden Lieferung." }]}
    relatedPages={[{ href: "/ugc-agentur", label: "UGC Agentur Deutschland" }, { href: "/ugc-agentur-berlin", label: "Berlin" }, { href: "/ugc-kaufen", label: "UGC kaufen" }]}
  />
);

export default UGCAgenturKoeln;
